import config from '../config'
import auth from '../app/auth'

import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

function get () {
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: auth.auth.signInUserSession.getIdToken().jwtToken
    }
  }))

  const httpLink = new HttpLink({
    uri: config.BACKEND_API_URL,
    credentials: 'same-origin'
  })
  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
      dataIdFromObject: o => o['_id']
    }),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache'
      }
    }
  })
}

export default {
  get
}
